/* LAIIRA motion layer script. Experimental, lives only in the Motion test theme. */
(function () {
  var d = document;
  var root = d.documentElement;
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  function esc(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function splitTitle(el) {
    if (el.getAttribute('data-lr-split')) return;
    el.setAttribute('data-lr-split', '1');
    el.setAttribute('aria-label', el.textContent.replace(/\s+/g, ' ').trim());
    var out = [];
    var i = 0;
    Array.prototype.forEach.call(el.childNodes, function (n) {
      if (n.nodeType === 3) {
        n.textContent.split(/\s+/).filter(Boolean).forEach(function (w) {
          out.push(`<span class="lr-w" aria-hidden="true"><span class="lr-w__i" style="--i:${i++}">${esc(w)}</span></span>`);
        });
      } else if (n.nodeName === 'BR') {
        out.push('<br>');
      }
    });
    el.innerHTML = out.join(' ');
  }

  function init() {
    try {
      var plan = [
        ['.lr-hero .lr-eyebrow', 0],
        ['.lr-hero__title', 1],
        ['.lr-hero__sub', 7],
        ['.lr-hero__actions', 8],
        ['.lr-drop__copy > *', null],
        ['.lr-drop__side > *', null],
        ['.lr-story__copy > *', null],
        ['.lr-faq__intro > *', null],
        ['.lr-faq__item', null],
        ['.product-card', null],
        ['#MainContent h2', null]
      ];
      var els = [];
      plan.forEach(function (p) {
        d.querySelectorAll(p[0]).forEach(function (el, idx) {
          if (el.hasAttribute('data-lr-reveal')) return;
          el.setAttribute('data-lr-reveal', p[0] === '.lr-hero__title' ? 'split' : 'up');
          el.style.setProperty('--lr-delay', p[1] === null ? idx % 4 : p[1]);
          els.push(el);
        });
      });
      var title = d.querySelector('.lr-hero__title');
      if (title) splitTitle(title);
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      els.forEach(function (el) { io.observe(el); });
      root.classList.add('lr-motion');
    } catch (err) {
      root.classList.remove('lr-motion');
    }
  }

  if (d.readyState === 'loading') {
    d.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
